<div class="canvas-container">
  <canvas
    id="{{ chartId }}"
    [attr.height]="height"
    [attr.width]="width"
  ></canvas>
</div>

<div
  id="items_radar_tooltip"
  *ngIf="id.startsWith('items_radar')"
  class="tooltip"
>
  <div *ngIf="tooltipDataPoints.length > 0" class="container">
    <p>
      כמות פריטים שנמכרו
      <span class="value">{{ tooltipDataPoints[0].formattedValue }}</span>
    </p>
    <p *ngIf="!isClinicOwner">
      מחיר ממוצע
      <span class="value"> {{ getTooltipData(tooltipDataPoints[0]) }} ש"ח</span>
    </p>
  </div>
</div>
